"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
/**
 * This directive was added to cover the apply  material design classes on dynamic generated pages.
 * This directive must be added to all components which uses MDL.
 */
var MaterialDesignLiteUpgradeDirective = /** @class */ (function () {
    function MaterialDesignLiteUpgradeDirective() {
    }
    MaterialDesignLiteUpgradeDirective.prototype.ngAfterViewInit = function () {
        componentHandler.upgradeAllRegistered();
    };
    MaterialDesignLiteUpgradeDirective = __decorate([
        core_1.Directive({
            selector: '[sis-mdl]'
        })
    ], MaterialDesignLiteUpgradeDirective);
    return MaterialDesignLiteUpgradeDirective;
}());
exports.MaterialDesignLiteUpgradeDirective = MaterialDesignLiteUpgradeDirective;
//# sourceMappingURL=material-design-lite-upgrade.directive.js.map